import { createContext, createElement, useCallback, useContext, useState } from "react";

const KEY = "lutazzi-theme";

const readTheme = () => {
  try {
    return localStorage.getItem(KEY) === "light" ? "light" : "dark";
  } catch {
    return "dark";
  }
};

const applyTheme = (t) => {
  const root = document.documentElement;
  root.classList.toggle("dark", t === "dark");
  root.style.colorScheme = t;
};

applyTheme(readTheme());

const ThemeContext = createContext({ theme: "dark", toggle: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readTheme);
  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      applyTheme(next);
      try {
        localStorage.setItem(KEY, next);
      } catch {}
      return next;
    });
  }, []);
  return createElement(ThemeContext.Provider, { value: { theme, toggle } }, children);
}

export const useTheme = () => useContext(ThemeContext);
